/****************************************************
 * Module Name:  consignmentReport.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Badge, Box, Button, Container, Tooltip, Typography } from "@mui/material";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import StoneDetailModal from "../common/stoneDetailModal";
import { styled } from "@mui/material/styles";
import NoPermission from "../common/noPermission";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import PageTitle from "../common/pageTitle";

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .super-app-theme--NEW": {
        backgroundColor: "#F9F08D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F9F08D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    '& .MuiDataGrid-columnHeader': {
        color: '#fff',
        backgroundColor: 'grey',
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "& .super-app-theme--LAB": {
        backgroundColor: "#7EAEEE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#7EAEEE",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
            color: "black",
        },
    },
    "& .super-app-theme--RE-LAB": {
        backgroundColor: "#FCCD91",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FCCD91",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK": {
        backgroundColor: "#FFFFCC",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FFFFCC",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_SENT": {
        backgroundColor: "#B8ACF6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B8ACF6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_DONE": {
        backgroundColor: "#388BFF",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#388BFF",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MIX": {
        backgroundColor: "#E0E88C",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#E0E88C",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE_APPROVAL_PENDING": {
        backgroundColor: "#FBDEDE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FBDEDE",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE": {
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--HOLD": {
        backgroundColor: "#B6B9D6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B6B9D6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MEMO_OUT": {
        backgroundColor: "#CAF7F6",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CAF7F6",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL": {
        backgroundColor: "#CCFF99",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CCFF99",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL_SENT": {
        backgroundColor: "#F797D2",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F797D2",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SOLD": {
        backgroundColor: "#26D4B9",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#26D4B9",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL_CANCELLED": {
        backgroundColor: "#F59598",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F59598",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },

}));

export default function ConsignmentReport() {
    const [stockData, setStockData] = useState([]);
    const [stockLoader, setStockLoader] = useState(false);

    const [stoneId, setStoneId] = useState("");
    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const [successSnackbar, setSuccessSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [sortModel, setSortModel] = React.useState([]);

    const [consignmentnoOption, setConsignmentnoOption] = useState([]);

    const [consignmentno, setConsignmentno] = useState([]);
    const [columnNames, setColumnNames] = React.useState([]);

    // eslint-disable-next-line
    const [localPermission, setLocalPermission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.REPORT_CONSIGNMENT
        )
    );
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        PageTitle("REPORT_CONSIGNMENT");
        getAllConsignmentNoData();
    }, []);

    useEffect(() => {
        handleSearch();
    }, [consignmentno]);

    const getAllConsignmentNoData = () => {

        setStockLoader(true);
        StoneProxy.GetAllConsignmentNo((response) => {
            if (response) {
                prepareConsignmentNoData(response);
            }
        })
    };

    const prepareConsignmentNoData = (response) => {

        let optionsArray = [];
        optionsArray.push({ value: "-1", label: "-- ANY --" });
        response.map((data) => {
            if (data && data !== "") {
                let option = {
                    value: data,
                    label: data,
                };
                optionsArray.push(option);
            }
            return true;
        });

        setConsignmentnoOption(optionsArray);
        setConsignmentno([optionsArray[0]]);
        return true;
    };

    const handleSearch = () => {

        setStockLoader(true);
        if (consignmentno && consignmentno.length > 0) {
            StoneProxy.GetStoneDetailByConsignmentNo(consignmentno[0].value, (response) => {
                if (response) {
                    prepareColumns();
                    setStockData(response);
                    setStockLoader(false);
                } else {
                    setStockLoader(false);
                    setErrorSnackbar(true);
                    setErrorMessage("Unable to fetch records")
                }
            });
        }
    };

    const handleClose = () => {
        setShowStoneDetailModal(false);
    };

    const handleStoneDetailModal = (params) => {
        setStoneId(params.value);
        setShowStoneDetailModal(true);
    };

    const prepareColumns = () => {
        let columnNames = [];

        Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
            if (columnsData.hasOwnProperty(iColPermission)) {
                const columnData = columnsData[iColPermission];
                columnNames.push(columnData);
                if (columnData.field === "status") {
                    if (columnsData.hasOwnProperty("936e9971-22f8-4fa7-b176-ea7fda100632")) {
                        columnNames.push({
                            field: "consignmentno",
                            headerName: "CONSIGN. No",
                            headerAlign: "center",
                            align: "center",
                            width: 140,
                        });
                    }
                    if (columnsData.hasOwnProperty("08a69194-0489-425a-9d6d-1933206a6e57")) {
                        columnNames.push({
                            field: "consignmentdate",
                            headerName: "CONSIGN. DATE",
                            headerAlign: "center",
                            align: "center",
                            width: 140,
                        });
                    }
                    if (columnsData.hasOwnProperty("39ebac04-5cf5-4bfa-8a03-78f0b40ec887")) {
                        columnNames.push({
                            field: "consignmentfrom",
                            headerName: "CONSIGN. FROM",
                            headerAlign: "center",
                            align: "center",
                            width: 140,
                        });
                    }
                }
            }
        });
        setColumnNames(columnNames);
    }

    const columnsData = {
        "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
            field: "stoneid",
            headerName: "STONEID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: (params) => Utility.NeedToShowStoneDetailModal() ? (
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handleStoneDetailModal(params)}
                >
                    {params.value}
                </Button>
            ) : (
                <div>{params.value}</div>
            ),
        },
        "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 100,
            cellClassName: (params) => `super-app-theme--${params.row.status.toUpperCase()}`,
            renderCell: renderCellExpand,
        },
        "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            align: "right",
            width: 40,
            renderCell: renderCellExpand,
        },
        "798a8663-0f0c-41be-8512-16dd60d5f25e": {
            field: "discount",
            headerName: "DIS",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
            renderCell: renderCellExpand,
        },
        "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
            field: "rapnetprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 50,
            renderCell: renderCellExpand,
        },
        "39c634f1-2644-4307-acbb-983b4de4229e": {
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            align: "right",
            width: 70,
            renderCell: renderCellExpand,
        },
        "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
            field: "total",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
            renderCell: renderCellExpand,
        },
        "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 75,
            renderCell: renderCellExpand,
        },
        "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 65,
            renderCell: renderCellExpand,
        },
        "3597803f-8932-40c6-8de6-81006f4d6d5b": {
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            width: 50,
            renderCell: renderCellExpand,
        },
        "8eaa8a03-d163-436d-8912-51ea06306f44": {
            field: "certificateid",
            headerName: "CERT",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 100,
            renderCell: renderCellExpand,
        },
        "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            minWidth: 190,
        },
        "8296e627-0be5-4a66-830f-ea6867cea137": {
            field: "flo",
            headerName: "FLO",
            headerAlign: "center",
            align: "center",
            width: 60,
            renderCell: renderCellExpand,
        },
        "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
            field: "lab",
            headerName: "LAB",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            renderCell: renderCellExpand,
        },
        "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
            field: "pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            renderCell: renderCellExpand,
        },
        "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
        },
        "5541c182-21b8-496e-b342-b0b89f3d302f": {
            field: "sym",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 40,
            renderCell: renderCellExpand,
        },
        "567202e6-c31c-4c19-9998-1cacae05af6e": {
            field: "depth",
            headerName: "DEPTH",
            headerAlign: "center",
            align: "center",
            width: 70,
            renderCell: renderCellExpand,
        },
        "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
            field: "height",
            headerName: "HEIGHT",
            headerAlign: "center",
            align: "center",
            width: 70,
            renderCell: renderCellExpand,
        },
        "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
            field: "width",
            headerName: "WIDTH",
            headerAlign: "center",
            align: "center",
            width: 70,
            renderCell: renderCellExpand,
        },
        "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
            field: "fancycolor1",
            headerName: "F.COLOR",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            renderCell: renderCellExpand,
        },
        "ccba9873-174e-4060-963a-9893c3625bb2": {
            field: "fancycolorovertone",
            headerName: "OVERTONE",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            renderCell: renderCellExpand,
        },
        "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
            field: "fancycolorintensity",
            headerName: "F.COL.INTENSITY",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: renderCellExpand,
        },
        "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
            field: "comment",
            headerName: "COMMENT",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            renderCell: renderCellExpand,
        },
        "e7210f4a-6e0a-4591-8428-e6845004ed04": {
            field: "crownheight",
            headerName: "CR.HEIGHT",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            renderCell: renderCellExpand,
        },
        "c4e65984-1682-4c1e-812b-8938e9078b2d": {
            field: "crownangle",
            headerName: "CR.ANG",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            renderCell: renderCellExpand,
        },
        "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
            field: "culetsize",
            headerName: "CULET SZ",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            renderCell: renderCellExpand,
        },
        "e3f77521-2c57-46bc-a02b-3c884685d2be": {
            field: "culetcondition",
            headerName: "CULET",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            renderCell: renderCellExpand,
        },
        "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
            field: "depthpercent",
            headerName: "DEPTH%",
            headerAlign: "center",
            align: "center",
            width: 75,
            renderCell: renderCellExpand,
        },
        "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
            field: "paviliondepth",
            headerName: "PV.DEPTH",
            headerAlign: "center",
            align: "center",
            minWidth: 180,
            renderCell: renderCellExpand,
        },
        "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
            field: "tablepercent",
            headerName: "TABLE%",
            headerAlign: "center",
            align: "center",
            width: 75,
            renderCell: renderCellExpand,
        },
        "ab3e506e-bddb-456d-b967-922dcee74d56": {
            field: "location",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "left",
            width: 130,
            renderCell: (params) => params.row.stoneoldstatus === null ? params.value : (
                <Box
                    sx={{
                        "& .MuiBadge-badge": {
                            height: "0.75rem !important",
                            padding: "2px 4px !important",
                            fontSize: "8px",
                            top: "-1px",
                            right: "-20px",
                            backgroundColor: "#E5D9F2 !important",
                            color: "#624E88 !important",
                            fontWeight: "700"
                        },
                    }}
                >
                    <Badge
                        badgeContent={"TRANSIT"}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        {params.value}
                    </Badge>
                </Box>
            ),
        },
        "e9028170-e978-4978-a2c9-1889c1821495": {
            field: "gridlecondition",
            headerName: "GIRDLE COND",
            headerAlign: "center",
            align: "center",
            minWidth: 110,
            renderCell: renderCellExpand,
        },
        "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
            field: "gridlepercent",
            headerName: "GIRDLE%",
            headerAlign: "center",
            align: "center",
            minWidth: 110,
            renderCell: renderCellExpand,
        },
        "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
            field: "pavilionangle",
            headerName: "PV.ANGLE",
            headerAlign: "center",
            align: "center",
            minWidth: 110,
            renderCell: renderCellExpand,
        },
        "7e356515-7cc5-4cd4-a1a4-a1b909b3b4e3": {
            field: "avgrapnetprice",
            headerName: "AVG RAP PRICE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "a330b2b8-b9e4-40bb-bb7a-d0e83a717a74": {
            field: "avgdiscount",
            headerName: "AVG DIS",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "1ac589a9-ff76-4b9a-9b6e-f0d7951dc0ca": {
            field: "avgprice",
            headerName: "AVG PRICE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "49b8f961-fe52-48ca-afbe-ceab5d7dc740": {
            field: "avgtotal",
            headerName: "AVG TOTAL",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "936e9971-22f8-4fa7-b176-ea7fda100632": {
            field: "consignmentno",
            headerName: "Consign. No",
            headerAlign: "center",
            align: "center",
            width: 140,
            type: "text",
            renderCell: renderCellExpand,
        },
        "08a69194-0489-425a-9d6d-1933206a6e57": {
            field: "consignmentdate",
            headerName: "Consign. DATE",
            headerAlign: "center",
            align: "center",
            width: 140,
        },
        "39ebac04-5cf5-4bfa-8a03-78f0b40ec887": {
            field: "consignmentfrom",
            headerName: "Consign. FROM",
            headerAlign: "center",
            align: "center",
            width: 140,
        },
    };

    const rows = stockData;

    const allowed = Utility.isReadAllowed(localPermission);

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: "block" }} />
                {stockLoader ? (
                    <CircularProgress sx={{ cursor: "pointer", height: "1.8rem !important", width: "1.8rem !important" }} />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            onClick={() => handleSearch()}
                            color="primary"
                            fontSize="large"
                            sx={{ cursor: "pointer", height: "1.8rem", width: "1.8rem" }}
                        />
                    </Tooltip>
                )}
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        )
    }

    return (
        !allowed ? <NoPermission /> :
            <div>
                <Container maxWidth="xxl">

                    {showStoneDetailModal ? (
                        <StoneDetailModal
                            show={showStoneDetailModal}
                            stoneId={stoneId}
                            handleClose={handleClose}
                        />
                    ) : null}

                    <TabMenuSnackbar
                        show={successSnackbar}
                        message={'Stone Updated Successfully'}
                        variant={"success"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Success"}
                        handleClose={() => setSuccessSnackbar(false)}
                    />

                    <TabMenuSnackbar
                        show={errorSnackbar}
                        message={errorMessage !== "" ? errorMessage : Constants.APiFailErrorMessage}
                        variant={"error"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Failed"}
                        handleClose={() => setErrorSnackbar(false)}
                    />

                    <Box m={1} display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                width: "100%",
                                mb: 3,
                                mt: 2,
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: "10px",
                                pl: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    width: { xs: "100%", sm: "auto" },
                                    gap: "10px",
                                }}
                            >
                                <Box
                                    sx={{
                                        alignSelf: "center",
                                        mt: { xs: 0, sm: 1 },
                                        width: { xs: "100%", sm: "133px" },
                                    }}
                                >
                                    <Typography>Consignment No</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        alignSelf: "center",
                                        width: { xs: "100%", sm: "280px", md: "298px" },
                                        mt: { xs: 0, sm: 1 },
                                    }}
                                >
                                    <Select menuPlacement="auto"
                                        blurInputOnSelect={false}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        value={consignmentno}
                                        isSearchable={true}
                                        name="status"
                                        menuPortalTarget={document.body}
                                        styles={Constants.Styles}
                                        options={consignmentnoOption}
                                        onChange={(selectedOption) => setConsignmentno([selectedOption])}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            height: '80vh',
                            "& .lavenderCell": {
                                color: "#080808",
                                backgroundColor: "#D8BFD8",
                            },
                            "& .redColor": {
                                backgroundColor: "#f5d7d7"
                            }
                        }}
                    >
                        <StyledDataGrid
                            disableRowSelectionOnClick={true}
                            localeText={{ noRowsLabel: "No Record Found" }}
                            sx={{ height: "80vh", fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight, }}
                            slots={{
                                toolbar: CustomToolbar,
                            }}
                            rows={rows}
                            sortModel={sortModel}
                            onSortModelChange={(newModel) => setSortModel(newModel)}
                            density="compact"
                            columns={columnNames}
                            getRowId={(row) => row.stoneid}
                            loading={stockLoader}
                            onColumnOrderChange={(params) => Utility.handleColumnOrderChange(params, columns, setColumns, window.location.pathname)}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns id, the other columns will remain visible
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: {
                                        debounceMs: 500,
                                    },
                                },
                            }}
                        />
                    </Box>

                </Container>
            </div >
    );
}